import { useQueryClient } from '@tanstack/react-query';
import { useCallback, useEffect } from 'react';
import { useSearchParams } from 'react-router';

import { EikaMessageEvent, parseCallback, useNativeEventListener } from '@eika-infrastruktur/mobilbank-lib';

type RNWebAction = 'BACK_TO_WEB';

export const NativeRedirectInvalidation = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const queryClient = useQueryClient();

    const invalidate = searchParams.get('invalidate');

    const backToWeb = useCallback(
        async (event: EikaMessageEvent<RNWebAction>) => {
            const data = parseCallback<RNWebAction>(event.data);

            if (data) {
                switch (data.action) {
                    case 'BACK_TO_WEB': {
                        queryClient.invalidateQueries({ queryKey: ['v4'] });
                        break;
                    }

                    default:
                        break;
                }
            }
        },
        [queryClient],
    );

    useNativeEventListener(backToWeb);

    useEffect(() => {
        if (invalidate === 'true') {
            queryClient.invalidateQueries({ queryKey: ['v4'] });

            setSearchParams((prev) => {
                prev.delete('invalidate');
                return prev;
            });
        }
    }, [invalidate, queryClient, setSearchParams]);

    return null;
};
